import { useEffect, useState } from 'react';
import axiosInstance from '@/lib/axios';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * GoogleAnalytics Component
 * Dynamically injects Google Analytics (gtag.js) based on configuration from backend
 */
export default function GoogleAnalytics() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const loadGoogleAnalytics = async () => {
      try {
        const response = await axiosInstance.get(`${API}/seo/google/config`);
        const { ga_measurement_id } = response.data;

        if (ga_measurement_id && !loaded) {
          // Add gtag.js script
          const script1 = document.createElement('script');
          script1.async = true;
          script1.src = `https://www.googletagmanager.com/gtag/js?id=${ga_measurement_id}`;
          document.head.appendChild(script1);

          // Add gtag initialization - Using safe method instead of innerHTML
          const script2 = document.createElement('script');
          script2.textContent = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${ga_measurement_id}', {
              page_path: window.location.pathname,
            });
          `;
          document.head.appendChild(script2);

          setLoaded(true);
          console.log('Google Analytics loaded:', ga_measurement_id);
        }
      } catch (error) {
        // Silently fail - GA is optional
        console.debug('Google Analytics not configured');
      }
    };

    loadGoogleAnalytics();
  }, [loaded]);

  return null; // This component doesn't render anything
}

/**
 * Hook to track page views in Google Analytics
 */
export function usePageTracking() {
  useEffect(() => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: window.location.pathname,
        page_title: document.title
      });
    }
  }, []);
}

/**
 * Track custom events in Google Analytics
 */
export function trackEvent(eventName, eventParams = {}) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
}

/**
 * Track simulation events
 */
export function trackSimulation(action, simulationData = {}) {
  trackEvent('simulation', {
    action,
    simulation_step: simulationData.step,
    property_price: simulationData.price,
    property_city: simulationData.city,
    ...simulationData
  });
}

/**
 * Track payment events
 */
export function trackPayment(action, paymentData = {}) {
  trackEvent('payment', {
    action,
    payment_method: paymentData.method,
    amount: paymentData.amount,
    ...paymentData
  });
}
